

class Core {
    constructor() {
        this.currentTimeout = null;
    };
    wait(timeout) {
        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
        };
        return new Promise(resolve => {
            this.currentTimeout = setTimeout(resolve, timeout);
        });
    };
};

window.addEventListener("load", function () {
    document.addEventListener('click', function(e) {
        const item = e.target.closest('#libraryMainsite-t-float_bottom .nav-item');
        if (!item) return;
        document.querySelectorAll('#libraryMainsite-t-float_bottom .nav-item')
            .forEach(el => el.classList.remove('active'));
        item.classList.add('active');
    }, true);
});
